import React from "react";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";

const MBConfirmationPopup = ({
  open,
  handleClose,
  handleConfirm,
  title,
  message,
  confirmText,
  cancelText,
  btnLoading,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={handleClose} variant="text" color="info" disabled={btnLoading}>
          {cancelText}
        </SoftButton>
        <SoftButton
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={btnLoading}
          startIcon={btnLoading ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {confirmText}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

// Define PropTypes
MBConfirmationPopup.propTypes = {
  open: PropTypes.bool.isRequired, // Whether the dialog is open
  handleClose: PropTypes.func.isRequired, // Function to close the dialog
  handleConfirm: PropTypes.func.isRequired, // Function to confirm deletion
  title: PropTypes.string, // Dialog title
  message: PropTypes.string, // Confirmation message
  confirmText: PropTypes.string, // Confirm button text
  cancelText: PropTypes.string, // Cancel button text
  btnLoading: PropTypes.bool, // Whether the confirm button is loading
};

// Default props
MBConfirmationPopup.defaultProps = {
  title: "Confirm Deletion",
  message: "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText: "Delete",
  cancelText: "Cancel",
  btnLoading: false, // Default to not loading
};

export default MBConfirmationPopup;
